// i18n
import { useTranslation } from 'react-i18next';

// mui
import { Alert, AlertTitle } from '@mui/material';

export interface AlertExchangeRatesProps {
	currency: string;
	currenciesForExchangeRates: string[];
}

export const AlertExchangeRates = ({
	currency,
	currenciesForExchangeRates = [],
}: AlertExchangeRatesProps) => {
	// hooks
	const { t } = useTranslation();

	if (!currency || currenciesForExchangeRates.length === 0) {
		return null;
	}

	const message = t('alert.exchangeRatesRequired', {
		currency,
		currenciesForExchangeRates: currenciesForExchangeRates.join(', '),
	});

	return (
		<Alert severity="info">
			<AlertTitle>{t('exchangeRatesRequired')}</AlertTitle>
			{message}
		</Alert>
	);
};
